import { useEffect, useRef, useState } from "react";
import { searchUsers } from "@/lib/afmApi";

// Super admin: busca una cuenta de artista por nombre o correo.
export default function AdminArtistSearch({ label, hint, onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const seq = useRef(0);
  useEffect(() => {
    const term = q.trim();
    const n = ++seq.current;
    if (term.length < 2) { setRows([]); setBusy(false); return undefined; }
    setBusy(true);
    const h = setTimeout(() => {
      searchUsers(term)
        .then((d) => { if (n === seq.current) setRows(Array.isArray(d) ? d : []); })
        .catch(() => { if (n === seq.current) setRows([]); })
        .finally(() => { if (n === seq.current) setBusy(false); });
    }, 300);
    return () => clearTimeout(h);
  }, [q]);
  return (
    <div data-testid="admin-artist-select" className="relative">
      {label && <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-600">{label}</label>}
      <input data-testid="admin-artist-search" value={q} onChange={(e) => setQ(e.target.value)} autoComplete="off"
        placeholder="Busca el artista por nombre o correo…" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none focus:border-black" />
      {q.trim().length >= 2 && (
        <div className="absolute z-20 mt-1 max-h-64 w-full overflow-auto rounded-lg border border-slate-200 bg-white shadow-lg" data-testid="admin-artist-results">
          {busy && <p className="px-3 py-2 text-xs text-slate-500">Buscando…</p>}
          {!busy && !rows.length && <p className="px-3 py-2 text-xs text-slate-500">Sin resultados</p>}
          {!busy && rows.map((u) => (
            <button key={u.id} type="button" data-testid={`admin-artist-option-${u.id}`} onClick={() => { setQ(""); onPick(u); }}
              className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-50">
              <span className="block font-semibold text-black">{u.stage_name || u.name}</span>
              <span className="block text-xs text-slate-500">{u.email}{u.has_plan ? " · plan activo" : " · sin plan activo"}</span>
            </button>
          ))}
        </div>
      )}
      {hint && <p className="mt-1 text-[11px] text-slate-500">{hint}</p>}
    </div>
  );
}
